// removed by extract-text-webpack-plugin
module.exports = {"describeForm":"hk-describeForm-describeForm","formFieldAreaItem":"hk-describeForm-formFieldAreaItem"};